module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-5-380-09c42841aaaadaca6d20946174f3512c.png";